import React, { useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";
import { SelectField, MenuItem } from "@curves/ui-base";
import { refIsRequiredError, getErrorModuleStatus } from "@util/utils";

/**
 * 教練欄位組件
 * 用於選擇教練
 */
const EmployeeField = React.forwardRef((props, ref) => {
	const { employeeOptions, readOnly, errorModule = {} } = props;
	const employeeRef = useRef();

	useImperativeHandle(
		ref,
		() => ({
			getResult: () => {
				return {
					receiverID: employeeRef.current?.getResult(),
				};
			},
			isError: () => refIsRequiredError(employeeRef),
		}),
		// eslint-disable-next-line
		[],
	);

	return (
		<Grid xs={5} item>
			<SelectField label="姓名" ref={employeeRef} disabled={readOnly} fullWidth required {...getErrorModuleStatus(errorModule, "receiverID")}>
				{Array.isArray(employeeOptions) &&
					employeeOptions
						.filter(item => item || !item.disabled)
						.map(item => (
							<MenuItem key={item.value} value={item.value}>
								{item.text}
							</MenuItem>
						))}
			</SelectField>
		</Grid>
	);
});

EmployeeField.displayName = "EmployeeField";

export default EmployeeField;

